// extracted by mini-css-extract-plugin
export default {"buttonSize":"DocumentoInvalidoModal_buttonSize__Zxnan","textSize":"DocumentoInvalidoModal_textSize__YluZ2"};